import { gql } from '@apollo/client';

import { RdTaxCreditContributorFragment } from './RdTaxCreditContributor.graphql';
import { TicketingProviderUserFragment } from './TicketingProviderUser.graphql';

/**
 * This is a fragment used to encapsulate the fields used when querying for a contributor plus its relations.
 */
export const GetRdTaxCreditContributorFragment = gql`
  fragment GetRdTaxCreditContributor on RdTaxCreditContributor {
    ...RdTaxCreditContributor
    ticketingProviderUsers {
      ...TicketingProviderUser
    }
  }
  ${RdTaxCreditContributorFragment}
  ${TicketingProviderUserFragment}
`;
